'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('@babel/runtime/helpers/extends');
var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _extends__default = /*#__PURE__*/_interopDefaultLegacy(_extends);
var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["selected", "children"];
// eslint-disable-next-line import/no-anonymous-default-export
function GroupButton (props) {
  var selected = props.selected,
      children = props.children,
      restProps = _objectWithoutPropertiesLoose__default["default"](props, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(bumbag.Button, _extends__default["default"]({
    _hover: {
      color: 'white',
      backgroundColor: '#1C69E8',
      borderColor: '#1C69E8'
    },
    _focus: {
      color: 'white',
      backgroundColor: '#1C69E8',
      borderColor: '#1C69E8'
    },
    variant: "outlined",
    palette: selected ? '#1C69E8' : '#616161',
    style: {
      fontWeight: selected ? 'bold' : 'normal',
      backgroundColor: !selected ? 'white' : '#E3F1FF'
    }
  }, restProps), children);
}

exports["default"] = GroupButton;
